import { render } from "./GcMemoryUsage.vue?vue&type=template&id=f76781ce"
import script from "./GcMemoryUsage.vue?vue&type=script&lang=js"
export * from "./GcMemoryUsage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__